'use client';
import { isElement } from '../../utils/dom.js';

function unwrapElement(element) {
    return !isElement(element) ? element.contextElement : element;
}

export { unwrapElement };
//# sourceMappingURL=unwrapElement.js.map
